import { render } from "./ShoppingCart.vue?vue&type=template&id=4899968f&scoped=true&bindings={}"
import script from "./ShoppingCart.vue?vue&type=script&lang=ts"
export * from "./ShoppingCart.vue?vue&type=script&lang=ts"

import "./ShoppingCart.vue?vue&type=style&index=0&id=4899968f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4899968f"

export default script